/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 23/05/2025 - 00:54:51
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 23/05/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useEffect, useState } from "react";
import Navbar from "../../components/shared/navbar";
import Footer from "../../components/shared/footer";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";
import AnalysisCheckoutForm from '../../components/pages/analysisCheckoutForm';

const AnalysisPayment: React.FC = () => {
  const [stripePromise, setStripePromise] = useState<Stripe | null>(null);
  const location = useLocation();
  const clientSecret = location?.state?.clientSecret;
  const analysisData = location?.state;

  useEffect(() => {
    const fetchStripePromise = async () => {
      const stripe = await loadStripe("pk_live_51OclhHFOvck8PfBnVyC2XXKoUe1Ov7E0YOkFvA2sag2jCUWl6bbKtpnCMAxAdKtop5wD3jcAgKEBGyuPr2uE019900Lcym8nz1");
      // const stripe = await loadStripe("pk_test_51OclhHFOvck8PfBnKGlKqGqDCa7pMPqaMb5HnYhGSSs4mjDA9Rfyo9782sxGmWCs2sVkevFeuFX6bNHQ46CIpug000A7qfW3JY");
      setStripePromise(stripe);
    };

    fetchStripePromise();
  }, []);

  // Validate that we have the required analysis payment data
  const hasValidAnalysisData = analysisData && 
    analysisData.clientSecret && 
    analysisData.orderId && 
    analysisData.paymentIntentId;

  return (
    <React.Fragment>
      {hasValidAnalysisData ? (
        <div>
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <AnalysisCheckoutForm />
          </Elements>
        </div>
      ) : (
        <div>
          <Navbar />
          <div className="text-center nothingToShow mt-5 pt-5">
            <h2>Analysis Payment Setup Incomplete</h2>
            <p className="text-muted mt-3">
              Please return to the analysis service page and try again.
            </p>
            <a href="/analysis-service" className="btn btn-primary mt-3">
              Back to Analysis Service
            </a>
          </div>
          <Footer />
        </div>
      )}
    </React.Fragment>
  );
};

export default AnalysisPayment;